import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import { AllocationViewActionIdentifierModel, AllocationViewFinishDepartureSecurityModel } from '../../models';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AllocationViewFinishDepartureSecurityActionService {
  constructor(private http: WrapperHttpService) {}

  departureSecurityFinish(data: AllocationViewFinishDepartureSecurityModel): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.DepartureSecurityFinish}`;

    return this.http.withLoading().post<void>(url, data);
  }

  departureSecurityFinishPrepare(
    actionIdentifier: AllocationViewActionIdentifierModel,
    currentLanguage: string,
  ): Observable<AllocationViewFinishDepartureSecurityModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.DepartureSecurityFinish}${AllocationViewEndpoint.Prepare}?lang=${currentLanguage}`;

    return this.http.withLoading().post<AllocationViewFinishDepartureSecurityModel>(url, actionIdentifier);
  }
}
